import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import Clock from '../../assets/img/clock.png'
import {  EMPTY_OBJECT, EVENT_LOG_TITLE, EVENT_TYPES } from '../../constants/globalConstants'
import noop from 'lodash/noop'
import URL from '../../constants/urls'
import { formatAMPM, formatDate, formatDateDays, formatMonthYear } from '../../utils/helper'
import { connect } from 'react-redux'
import { storeEventLog } from '../../redux/actions/eventLogActions'
import getConfigDetails from '../../services/config'
import Loader from '../global/Loader'
import {getImage } from '../../utils/helper'
import {BookSingleEventAnalytics} from '../../utils/GoogleAnalytics'
import useNetwork from '../../hooks/NetworkDetector'
import { bookingAllowTime ,bookingMsg} from '../../utils/helperTimeZone'
import { Tooltip} from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'



function Event(props) {
	const { eventData,event_type, dispatch , loader, isEventsLoading} = props
	const [isLoading, setIsLoading] = useState(false)
	// const [isLoading, setIsLoading] = useState(false)

	const navigate = useNavigate()
	const isOnline = useNetwork()


	useEffect(() => {
		setIsLoading(loader)
		
	}, [loader])
	
	const ClickBookEventAnalytics = (data) => {
		BookSingleEventAnalytics(data)
		
	}
	const handleBookParking = (res, val) => {
		if(isOnline){
			const payload = {
				'error_message': JSON.stringify(val),
				'facility_id': getConfigDetails.FACILITY_ID,
				'event_name': EVENT_LOG_TITLE?.BOOK_NOW_SINGLE_EVENT,
				'user_id': 0,
				'user_ip': localStorage.getItem('user_ip')
			}
			dispatch(storeEventLog(payload))
			if(Number(val.event_rate) <= 0){
				val.event_rate = val?.facilities?.length > 0 ? val?.facilities[0]?.base_event_rate : '0.00'
			}
			localStorage.setItem(EVENT_TYPES?.EVENT,JSON.stringify(val))

			const EventAnalyticsPayloads = {
				event_type: event_type,
				facility_id: getConfigDetails.FACILITY_ID,
				card_data:val
			}
			ClickBookEventAnalytics(EventAnalyticsPayloads)

			navigate(URL.PAYMENT)
		}
	}

	


	const homes = eventData?.eventData ? Object.values(eventData?.eventData) : null

	
	return (


		<div className="accordion" id="accordionExample">

			{isEventsLoading ? <Loader eventsLoader/> : homes?.map((home, index) => {
				return (
				<div key={index} className="accordion-item  mb-3 text-white ">
							<div
								className="accordion-header bg-primary p-2"
								id={`headingOne_${index}`}
							>
								<div
								
									className={
										index == 0
											? 'row g-0  align-items-center '
											: 'row g-0  align-items-center collapsed   '
									}
									type="button"
									data-bs-toggle="collapse"
									data-bs-target={`#collapseOne_${index}`}
									aria-expanded="true"
									aria-controls={`collapseOne_${index}`}
								>
									<div className="col p-2 d-none d-sm-block">
										<h4 className="m-0">
											{formatMonthYear(home[0]?.start_time)}
										</h4>
									</div>
									<div className="col p-2 text-center mobileFix">
										<h4>{home?.length} {home?.length > 1 ? 'Events' : 'Event'}</h4>
										<p className='d-block d-sm-none m-0'>{formatMonthYear(home[0]?.start_time)}</p>
									</div>
									

									<div className=" col text-end p-2">
										<div className='imgUp'></div>
									</div>
								</div>
							</div>
							<div
								id={`collapseOne_${index}`}
								className={
									index == 0
										? 'accordion-collapse collapse show'
										: 'accordion-collapse collapse'
								}
								aria-labelledby={`headingOne_${index}`}
								data-bs-parent="#accordionExample"
							>
								<div className="accordion-body p-0">
									<div className="table-responsive">
										<table className="table tableTime ">
											<thead className='row g-0'>
												<th className="col">Date</th>
												<th className="col">Game Start</th>
												<th className="col">Playing Against</th>
												<th className="col">Rate</th>
												<th className="text-end col"></th>
											</thead>
											<tbody>
											{isLoading ? <Loader eventsLoader/> :
											home.length > 0 ? home?.map((val, idx) => {
													
													return (
														<tr className='row g-0' key={idx}>
															<td className='col'>
																
																	<b>{formatDate(val?.start_time)}</b>
															
																, <small>{formatDateDays(val?.start_time)}</small>
															</td>
															<td className='col'>
																<img src={Clock} width="15px" alt="Clock" /> &nbsp;
																{formatAMPM(val?.start_time)}{' '}
																{val?.parking_time_message ? <small className='d-block lh-sm'>{val?.parking_time_message}</small>: null}
															</td>
															<td className='col'>
																<div className='d-flex align-items-center'>
																	<div>
																	<img width="50px" src={getImage(val)} alt="" />

																	</div>
																<div style={{lineHeight:'20px', marginLeft:'10px' }}> {val?.slug}</div>
																</div>
																{/* {/ <img src={Compti} width="45px" alt="Compti" /> /} */}
															
															</td>
															<td className='col'>${val.event_rate > 0 ? val.event_rate : val?.facilities?.length>0 ? val?.facilities[0]?.base_event_rate : '0.00'}</td>
															<td className="text-end col">
															{
																event_type==EVENT_TYPES?.EVENT && <div data-tooltip-place={'left-start'}  data-tooltip-id={bookingAllowTime(val) ? 'book-tooltip' : 'non-book-tooltip'} data-tooltip-content={bookingMsg}><button
																	href="#"
																	className="btn btn-danger text-white"
																	onClick={(e) => !bookingAllowTime(val) ? handleBookParking(e, val) :null}
																	disabled={bookingAllowTime(val)}
																>Book Now
																</button></div>
															}
															</td>
														</tr>
													)
												}): null }
											</tbody>
										</table>
										<Tooltip id="book-tooltip" className="maxWidth200" />
									</div>
								</div>
							</div>
						</div>
					
				)
			})}

			
		</div>
	)
}
Event.propTypes = {
	eventData: PropTypes.object,
	event_type:PropTypes.string,
	dispatch:PropTypes.func,
	loader: PropTypes.bool,
	isEventsLoading: PropTypes.bool,
}

Event.defaulProps = {
	eventData: EMPTY_OBJECT,
	event_type:undefined,
	dispatch: noop,
	loader: false,
	isEventsLoading: false,
}

function mapStateToProps({ eventLogReducer, eventDetailsReducer }) {
	return {
		data: eventLogReducer,
		loader: eventDetailsReducer.loader
	}
}
export default connect(mapStateToProps)(Event)
